import React, { useState } from "react";
import "./Carousel.css";
import CarouselSlide from "./CarouselSlide";
import Slide from "@material-ui/core/Slide";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Droppable } from "react-beautiful-dnd";

function Arrow(props) {
  const { direction, clickFunction } = props;
  const icon = direction === "left" ? <ArrowBackIcon /> : <ArrowForwardIcon />;

  return (
    <div style={{ height: "15px", cursor: "pointer" }} onClick={clickFunction}>
      {icon}
    </div>
  );
}

function CarrouselMini({ urls, idTipoDocumentacion }) {
  const [index, setIndex] = useState(0);
  const content = urls[index];
  const numSlides = urls.length;

  const [slideIn, setSlideIn] = useState(true);
  const [slideDirection, setSlideDirection] = useState("down");

  const onArrowClick = (direction, e) => {
    e.stopPropagation() || e.preventDefault();
    const increment = direction === "left" ? -1 : 1;
    const newIndex = (index + increment + numSlides) % numSlides;

    const oppDirection = direction === "left" ? "right" : "left";
    setSlideDirection(direction);
    setSlideIn(false);

    setTimeout(() => {
      setIndex(newIndex);
      setSlideDirection(oppDirection);
      setSlideIn(true);
    }, 500);
  };

  return (
    <div className="Micarousel">
      {
        numSlides > 1 &&
        <Arrow
          direction="left"
          clickFunction={(e) => onArrowClick("left", e)}
        />
      }
      <Slide in={slideIn} direction={slideDirection}>
        <div>
          <Droppable
            key={idTipoDocumentacion}
            droppableId={`docu${idTipoDocumentacion}`}
          >
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {
                  content &&
                  <CarouselSlide {...provided.droppableProps} ref={provided.innerRef} content={content} indice={index} />
                }

                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </Slide>
      {
        numSlides > 1 &&
        <Arrow
          direction="right"
          clickFunction={(e) => onArrowClick("right", e)}
        />
      }
    </div>
  );
}

export default CarrouselMini;
